var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-pagination',{attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.myModel),callback:function ($$v) {_vm.myModel=$$v},expression:"myModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }